// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q2fUWbD1KWKFmopsFSas{padding-top:40px}.bRk6N34i1YJuhsg9Vwvm{padding-top:31px;padding-left:4px}.d2hOypvve6srCfptOWmh{color:var(--content-brand-primary);cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/VerifyNumberCommon/ui/styles.module.scss"],"names":[],"mappings":"AAGA,sBACE,gBAAA,CAGF,sBACE,gBAAA,CACA,gBAAA,CAGF,sBACE,kCAAA,CACA,cAAA","sourcesContent":[".wrap {\n}\n\n.content {\n  padding-top: 40px;\n}\n\n.textBottomWrap {\n  padding-top: 31px;\n  padding-left: 4px;\n}\n\n.link {\n  color: var(--content-brand-primary);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Q2fUWbD1KWKFmopsFSas`,
	"textBottomWrap": `bRk6N34i1YJuhsg9Vwvm`,
	"link": `d2hOypvve6srCfptOWmh`
};
export default ___CSS_LOADER_EXPORT___;
